import React from 'react';
import './with-spiner.style.scss';

const  WithSpiner = ()=>(

<div>


<div className="preloader">
  <div className="preloader__ring">
    <div className="preloader__sector">Б</div>
    <div className="preloader__sector">И</div>
    <div className="preloader__sector">О</div>
    <div className="preloader__sector">Ц</div>
    <div className="preloader__sector">И</div>
    <div className="preloader__sector">Д</div>
    <div className="preloader__sector">И</div>
    <div className="preloader__sector">Е</div>
    <div className="preloader__sector">Д</div>
    <div className="preloader__sector">У</div>
    <div className="preloader__sector">К</div>
    <div className="preloader__sector">А</div>
    <div className="preloader__sector">Ц</div>
    <div className="preloader__sector">И</div>
    <div className="preloader__sector">Ј</div>
    <div className="preloader__sector">А</div>
    <div className="preloader__sector">.</div>
    <div className="preloader__sector">.</div>
    <div className="preloader__sector">.</div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
  </div>
</div>

</div>
)

export default WithSpiner;